if(document.getElementById('pdpFrame')){
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  const propertyId = document.getElementById('pdpFrame').getAttribute('data-propertyid');
  const userRoute = urlParams.get('ibuy_ab_vst') ? `&ab_vst=${urlParams.get('ibuy_ab_vst')}` : '';
  const useragent = `&pdpUseragent=${navigator.userAgent}`;
  const userInfo = MOVE && MOVE.Common && MOVE.Common.parseCookie()["regID"] ? `&userInfo=${MOVE.Common.parseCookie()["regID"]}` : '';
  const spotOfferURL = `https://www.realtor.com/sell/sellers-marketplace/pdp-ssr?propertyId=${propertyId}${userRoute}${userInfo}${useragent}`;
  const pdpFrame = document.getElementById('pdpFrame');

  const loadDeferredIframe = () => {
    let iframe = document.createElement('iframe');
    iframe.src = `/sell/sellers-marketplace/pdp-frame?propertyId=${propertyId}${userRoute}${useragent}`;
    iframe.onload = () => {
        const hasChildAlready = document.getElementById('pdpIframe').querySelector('iframe');
        if(!loaded && hasChildAlready === null){
            document.getElementById('pdpIframe').append(document.getElementById('spotOffer'));
            loaded = true;
        } else if (hasChildAlready){
            loaded = true;
        }
    }
    iframe.id = 'spotOffer';
    iframe.scrolling = 'no';
    iframe.loading= 'lazy';
    iframe.style.border = 'none';
    iframe.style.overlow = 'hidden';
    iframe.style.height = '100%';
    iframe.style.position = 'absolute';
    iframe.style.background = 'transparent';
    document.body.appendChild(iframe);
    setTimeout(() => {
        const hasChildAlready = document.getElementById('pdpFrame').querySelector('iframe');
        if(hasChildAlready === null){
            document.getElementById('pdpFrame').append(document.getElementById('spotOffer'));
            document.getElementById('loadingIndicator').remove();
        }
    },1500);
  }

  const getSpotOfferMarkup = () => {
    const addToPage = (doc) => {
      let spotOffer = document.createElement('div');
      Array.prototype.slice.call(doc.head.getElementsByTagName('style')).map((stylesheet) => {
        spotOffer.append(stylesheet);
      });
      spotOffer.append(doc.body.getElementsByTagName('main')[0]);
      document.getElementById('loadingIndicator').remove();
      pdpFrame.appendChild(spotOffer);
    }

    const fetchHTML = () => {
      fetch(spotOfferURL, {
        method: 'GET',
        mode: 'cors',
        cache: 'no-store',
      })
      .then((res) => res.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        addToPage(doc);
      })
      .catch((err) => {
        loadDeferredIframe();
        console.error(err);
      });
    }

    fetchHTML();
  }

  getSpotOfferMarkup();
}


// WEBPACK FOOTER //
// ./ldp/common_platform/critical_components/pdp_offer.js